import { createContext, useContext, useEffect, useState } from "react";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";
import { useAuthContext } from "@/auth";
import { createBrowserSafeId } from "@/utils/createBrowserSafeId";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { auth } = useAuthContext();
  const userId = auth?.user?.id;

  const [connected, setConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // || auth?.user?.company_is_active === 0
    if (!userId) return;

    const token =
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");
    const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

    window.Pusher = Pusher;

    const echo = new Echo({
      broadcaster: "reverb",
      key: import.meta.env.VITE_REVERB_APP_KEY,
      wsHost: import.meta.env.VITE_REVERB_HOST,
      wsPort: Number(import.meta.env.VITE_REVERB_PORT) || 80,
      wssPort: Number(import.meta.env.VITE_REVERB_PORT) || 443,
      // wsPath: "/oak-development",
      forceTLS: (import.meta.env.VITE_REVERB_SCHEME || "https") === "https",
      enabledTransports: ["ws", "wss"],
      // path: '/oak-development',
      authorizer: (channel, options) => {
        return {
          authorize: (socketId, callback) => {
            axios
              .post(
                `${BASE_URL}/broadcasting/auth`,
                {
                  socket_id: socketId,
                  channel_name: channel.name,
                  userId: userId,
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then((response) => {
                callback(false, response.data);
              })
              .catch((error) => {
                callback(true, error);
              });
          },
        };
      },
    });

    const channel = echo.private(`App.Models.User.${userId}`);
    channel.notification((event) => {
      const rawData = event?.data;
      let payload = rawData ?? event ?? {};

      if (typeof rawData === "string") {
        try {
          payload = JSON.parse(rawData);
        } catch {
          payload = { message: rawData };
        }
      }

      const message = payload?.message ?? event?.message;
      const time = payload?.time ?? event?.time;
      const type = payload?.type ?? event?.type;
      const readAt = event?.read_at ?? payload?.read_at ?? null;
      const notifyUserId = event?.userId ?? payload?.userId;
      const contactId = payload?.contact_id ?? event?.contact_id ?? null;

      if (message) {
        console.log("is in if when notified ?????");

        setNotifications((prev) => [
          {
            id: createBrowserSafeId(), // when broadcasting to frontend need id to differentiate
            data: {
              ...payload,
              message,
            },
            time,
            type,
            uuid: notifyUserId,
            read_at: readAt,
            contact_id: contactId,
          },
          ...prev,
        ]);
      }
    });
    // .notification((notification) => {

    //     console.log("Notification received:", notification);

    // });

    // const channel = echo.private(`App.Models.User.${userId}`);
    // // `.PrivateMessageEvent`,
    // channel.notification('notfication', (payload) => {
    //   const message = payload?.message;
    //   if (message) {
    //     setNotifications(prev => [
    //       { id: crypto.randomUUID(), data: { message }, uuid: payload?.userId, read_at: payload?.read_at ?? null },
    //       ...prev,
    //     ]);
    //   }
    // });


    // channel.notification((event) => {
    //   const message = event?.message;

    //   if (message) {
    //     console.log('is in if when notified ?????');

    //     setNotifications((prev) => [
    //       {
    //         id: crypto.randomUUID(), // when broadcasting to frontend need id to differentiate
    //         data: { message },
    //         uuid: event?.userId,
    //       },
    //       ...prev,
    //     ]);
    //   }
    // });

    echo.connector.pusher.connection.bind("connected", () => {
      setConnected(true);
    });

    echo.connector.pusher.connection.bind("disconnected", () => {
      setConnected(false);
    });

    return () => {
      // channel.stopListening(`.PrivateMessageEvent.${userId}`);
      echo.disconnect();
    };
  }, [userId]);

  const pushInitialNotifications = (data) => {
    // The API hands admins the whole firm's notifications, but this store backs
    // the personal bell and its unread badge. You can only mark your own as
    // read, so keeping other people's here leaves a badge that never clears —
    // which is exactly what an admin saw once their own were all read.
    // Rows with no notifiable_id arrive on your private socket channel and are
    // yours by definition.
    setNotifications(
      (data ?? []).filter(
        (n) => n?.notifiable_id == null || String(n.notifiable_id) === String(userId)
      )
    );
  };

  return (
    <SocketContext.Provider
      value={{ connected, notifications, pushInitialNotifications }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
